// Update the src/pages/GlobalSettingsPage.js file

import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { 
  Container, 
  Typography, 
  Alert, 
  Box 
} from '@mui/material';
import SettingsFrom from '../sections/@dashboard/settings/Form';
import { useAuthContext } from '../auth/useAuthContext';
import axios from '../utils/Axios';
import saveErrorMessage from '../utils/saveErrorMessage';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function GlobalSettingsPage() {
  const { user, setGlobalUser } = useAuthContext();
  const [status, setStatus] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const dismissTimer = useRef(null);

  useEffect(() => () => clearTimeout(dismissTimer.current), []);

  // A failed save used to reject with nothing catching it: the owner clicked Save, saw
  // no message, and could reasonably assume it had worked. Validation messages from the
  // server name the day and say what to change, so they are shown as sent.
  //
  // The error is re-raised so the form can record the save as unsuccessful, which keeps
  // its unsaved-changes warning in place. The form catches it; see settings/Form.js.
  const updateUser = useCallback(async (userData) => {
    clearTimeout(dismissTimer.current);

    // Only the request is inside the try. If updating the page after a successful save
    // threw, the owner would be told the save failed when the server had saved it.
    let response;
    try {
      response = await axios.put(`/user`, userData);
    } catch (error) {
      console.error('Global Settings save failed', error);
      // Not dismissed on a timer. An error the owner has to act on should stay until
      // they act, not vanish while they are reading it.
      setStatus({ severity: 'error', message: saveErrorMessage(error) });
      // The message sits above a long form, and Save is at the bottom of it.
      window.scrollTo({ top: 0, behavior: 'smooth' });
      throw error;
    }

    setGlobalUser(response.data.user);
    setStatus({ severity: 'success', message: 'Settings Updated.' });
    dismissTimer.current = setTimeout(() => setStatus(null), 6000);
  }, [setGlobalUser]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Helmet>
        <title>Global Settings | {localStorage.getItem("companyName") ?? "FlowBookings"}</title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Global Settings
        </Typography>
        
        {status != null && (
          <Alert
            severity={status.severity}
            onClose={status.severity === 'error' ? () => setStatus(null) : undefined}
            sx={{ mt: 2, mb: 2, whiteSpace: 'pre-line' }}
          >
            {status.message}
          </Alert>
        )}

        {/* <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="settings tabs">
            <Tab label="General Settings" />
            <Tab label="Integrations" />
          </Tabs>
        </Box> */}

        {/* <TabPanel value={tabValue} index={0}> */}
          <SettingsFrom config={user.config} updateUser={updateUser} />
        {/* </TabPanel> */}

        {/* <TabPanel value={tabValue} index={1}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <ApiKeyManager />
            </Grid>
            <Grid item xs={12} md={6}>
              <ZapierIntegration />
            </Grid>
          </Grid>
        </TabPanel> */}
      </Container>
    </>
  );
}